export const SET_ACTIVITYS = 'Set_Activity';